import {defineMessages} from "react-intl";

export const not_found = defineMessages({
    text_1: {id: "not-found-text-1", defaultMessage: "Un problème est survenue"},
    text_2: {id: "not-found-text-2", defaultMessage: "Il semble qu'une erreur se soit produite ou que la page que vous recherchez n'existe pas. Si le problème persiste, n'hésitez pas à nous en informer."},
});